<template>
  <main class="nk-pages">
    <section class="section section-l bg-white paddTop">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-8">
            <div class="section-head text-center wide-auto-sm">
              <h2 class="title title-lg title-dark">What NIPOST ESTAMP can do for you?</h2>
              <p>Imaxinacion Technologies built the QuBit app as a Commercial app.<br />
                This SERVICE is provided by Imaxinacion Technologies and<br />is intended for use as is.</p>
            </div>
            <div class="hr"></div>
            <div class="gap-3x"></div>
            <div class="nk-block-text">
              <h2 class="title">About</h2>
              <p>This page is used to inform users regarding our policies with the collection, use, and disclosure of Personal
                Information if anyone decided to use our Service. If you choose to use our Service, then you agree to the collection
                and use of information in relation to this policy. The Personal Information that we collect is used for providing
                and improving the Service. We will not use or share your information with anyone except as described in this Privacy
                Policy. The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, which is accessible
                at QuBit unless otherwise defined in this Privacy Policy.</p>    
            </div>
            <div class="gap-3x"></div>
            <div class="hr"></div>
            <div class="gap-3x"></div>
            <div class="nk-block-text">
              <h2 class="title"> Information <br class="d-none d-md-block" />Collection and Use</h2>
              <p>For a better experience, while using our Service, we may require you to provide us with certain personally
                identifiable information. The information that we request will be retained by us and used as described in this privacy
                policy. The app does use third party services that may collect information used to identify you. Link to privacy
                policy of third party service providers used by the app</p>
            </div>
            <div class="gap-3x"></div>
            <div class="hr"></div>
            <div class="gap-3x"></div>
            <div class="nk-block-text">
              <h4 class="title title-md">Security</h4>
              
              <p>We value your trust; thus, we are striving to use commercially acceptable means of protecting it. But remember
                that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and we
                cannot guarantee its absolute security.</p>
            </div>
            <div class="gap-3x"></div>
            <div class="hr"></div>
            <div class="gap-3x"></div>
            <div class="nk-block-text">
              <h6 class="title title-xs tc-primary">Changes to This Privacy Policy</h6>
              <p>We may update our Privacy Policy from time to time. Thus, you are advised to review this page periodically for any
                changes. We will notify you of any changes by posting the new Privacy Policy on this page. These changes are effective
                immediately after they are posted on this page.</p> 
            </div>
            <div class="gap-3x"></div>
            <div class="hr"></div>
            <div class="gap-3x"></div>
            <div class="nk-block-text text-center">
              <h6 class="title title-xs tc-primary">Contact Us</h6>
              <p>If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us at admin@imaxinacion.net.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {

}
</script>

<style>

</style>
